module.exports = __webpack_public_path__ + "img/usa-eye-and-ear-diseases-female.b1f583dc.png";